import { render } from "./SupplierData.vue?vue&type=template&id=28d314b4&ts=true"
import script from "./SupplierData.vue?vue&type=script&lang=ts"
export * from "./SupplierData.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__